<script setup>
// 서비스 소개
import SectionBase from '@/components/about-nangman/SectionBase.vue';
import { canonicalUrl, applySeoMeta } from '@/utils/seo';
import { addContentLogAPI } from '@/api/logServiceApi';

definePage({ meta: { layout: 'intro', title: '낭만만세력은?' } });

const route = useRoute();

applySeoMeta({
  title: '정확한 만세력, 사주팔자, 만세력 해석',
  description:
    '천문역법에 기반한 정확한 사주 계산, 야자시·한국시·입춘 기준 선택, 해외 시차 보정, 사주 간지 역추적까지. 낭만만세력의 철학과 차별점을 소개합니다.',
  url: canonicalUrl(route.fullPath),
});

// 서비스 안내 페이지 진입 로그 (신규 type, DB 등록 후 작동)
onMounted(() => {
  addContentLogAPI('S_service_guide_view');
});
</script>

<template>
  <SectionBase />
</template>

<style lang="scss">
@import '@/assets/css/about-page.scss';
@import '@/assets/css/about-page-mobile.scss';
@import '@/assets/webview/com_popup.scss';
.only-pc {
  display: flex !important;
}
.only-mobile {
  display: none !important;
}
.intro-section__wrapper.only-mobile {
  height: 0 !important;
}
.intro-section__wrapper.only-pc {
  display: block !important;
}
@media (max-width: 768px) {
  .only-pc {
    display: none !important;
  }
  .only-mobile {
    display: flex !important;
  }
  .intro-section__wrapper.only-mobile {
    height: auto !important;
  }
  .intro-section__wrapper.only-pc {
    display: none !important;
  }
}
</style>
